import { makeStyles, Badge, shorthands } from "@fluentui/react-components";
import { IStatusBadgesProps } from "./status-badges.props";

const layoutStyles = makeStyles({
    mainWrapper: {
        display: 'flex',
        flexWrap: 'wrap',
        ...shorthands.gap('8px'),
        alignItems: 'center'
    }
});

export default function StatusBadges(props: IStatusBadgesProps) {
    const styles = layoutStyles();

    if (!props.statuses || props.statuses.length === 0) {
        return null;
    }

    return (
        <div className={styles.mainWrapper}>
            {props.statuses.map((status, idx) => (
                <Badge
                    key={idx}
                    size="small"
                    appearance="tint"
                    color="warning">
                    {status}
                </Badge>
            ))}
        </div>
    );
}
